export const contactData = {
  email: "sivakarthick0815@gmail.com",
  phone: "+91 6374038984",
  location: "Coimbatore, India",
  social: {
    linkedin: "https://linkedin.com/in/sivakarthickb",
    github: "https://github.com/Siva05-code",
    leetcode: "https://leetcode.com/u/siva0801"
  }
};
